import type { ReactNode } from 'react'
import css from './FormRow.module.css'

interface FormRowProps {
    children: ReactNode
    align?: 'stretch' | 'start' | 'center' | 'end' | 'left' | 'space-between'
    width?: number
    gap?: string | number
}

const FormRow = ({ children, align = 'center', width, gap }: FormRowProps) => {
    const alignValue = align === 'left' ? 'flex-start' : align
    const gapValue = typeof gap === 'number' ? `${gap}px` : gap
    const style: React.CSSProperties = {
        justifyContent: alignValue,
        alignItems: alignValue,
        ...(width && { flex: `0 0 ${width}px` }),
        ...(gap !== undefined && { gap: gapValue })
    }

    return (
        <div className={css.form_row} style={style}>
            {children}
        </div>
    )
}

export default FormRow
